export type VehicleAlert = { label: string; reasons: string[] };

/** 積載の超過。表示項目で今どれを見ているかに関わらず 3 つとも判定する */
export type OverloadFlags = { quantity?: boolean; weight?: boolean; volume?: boolean };

type Params = {
  enabled: boolean;
  overloads?: OverloadFlags;
  /** 積載以外の制約違反。勤務時間・指定時間など呼び出し側が判定して渡す */
  constraintAlerts?: readonly string[];
};

// 文言と並び順は V3Plans (PlanningsDelivery.presenter.tsx:269-275) に合わせる。
// 同じ違反が画面ごとに違う名前で出ると、どちらが正しいのか読み手に判断できない
const OVERLOAD_REASONS: [keyof OverloadFlags, string][] = [
  ['quantity', '数量が超過しています。'],
  ['weight', '重量が超過しています。'],
  ['volume', '体積が超過しています。'],
];

/**
 * 車両カード右上の警告バッジ。
 * サンプル (route-planner: components/dispatch/VehicleInfo.tsx:98-101) と同じく
 * 積載超過と制約違反を 1 つにまとめ、Tooltip で理由を並べる。
 *
 * Why not 表示中の項目だけ見る: 配車結果が違反している事実は表示設定で変わらない。
 * 数量を表示しているときに重量超過が消えると、違反に気づけない（報告）。
 *
 * Why not 理由が 1 件のときは名前をそのまま出す: 「アイコン＋積載超過」で幅を取り、
 * 同じ段に並ぶ積込・納品バッジを押し出していた。ラベルは件数に統一し、
 * 何の制約かは Tooltip で見せる。
 */
export function buildVehicleAlert({ enabled, overloads, constraintAlerts }: Params): VehicleAlert | null {
  // 稼働しない車両は配車対象外なので、超過していても警告の意味を持たない
  if (!enabled) return null;

  const reasons = OVERLOAD_REASONS.filter(([key]) => overloads?.[key]).map(([, reason]) => reason);
  if (constraintAlerts) reasons.push(...constraintAlerts);

  if (reasons.length === 0) return null;
  return { label: `制約 ${reasons.length}`, reasons };
}
